<template>
    <div class="overflow-hidden absolute inset-0 pointer-events-none rounded-inherit "
        style="outline: transparent dashed 2px;">
        <div v-if="orientation === 90" :class="`absolute inset-0 w-full h-full transform translate-x-full`">
            <div class="absolute transform origin-top-left rotate-90" style="width: 1080px; height: 1920px;">
                <div class="absolute inset-0 overflow-hidden">
                    <div class="absolute inset-0" draggable="false" :style="{...addStyle()}">
                    </div>
                </div>
            </div>
        </div>
        <div v-if="orientation === 180" class="absolute inset-0 w-full h-full transform origin-center rotate-180">
            <div class="absolute inset-0 overflow-hidden">
                <div class="absolute inset-0" draggable="false" :style="{...addStyle()}">
                </div>
            </div>
        </div>
        <div v-if="orientation === 270" class="absolute inset-0 w-full h-full transform translate-x-full">
            <div class="absolute transform origin-top-left rotate-90" style="width: 1080px; height: 1920px;">
                <div class="absolute inset-0 w-full h-full transform origin-center rotate-180">
                    <div class="absolute inset-0 overflow-hidden">
                        <div class="absolute inset-0   " draggable="false"
                        :style="{...addStyle()}">
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
export default {
    name: "imageOrientation",
    props: {
        url: String,
        orientation: Number
    },
    methods: {
        addStyle() {
            let obj = {
                'background-image': `url(${this.url})`,
                'opacity': 1,
                'background-repeat': 'no-repeat',
                'background-size': 'cover',
                'background-position': 'center center'
            }
            return obj
        }
    }
}
</script>

<style scoped>
*,
::after,
::before {
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x: ;
    --tw-pan-y: ;
    --tw-pinch-zoom: ;
    --tw-scroll-snap-strictness: proximity;
    --tw-ordinal: ;
    --tw-slashed-zero: ;
    --tw-numeric-figure: ;
    --tw-numeric-spacing: ;
    --tw-numeric-fraction: ;
    --tw-ring-inset: ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgba(97, 125, 238, .5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur: ;
    --tw-brightness: ;
    --tw-contrast: ;
    --tw-grayscale: ;
    --tw-hue-rotate: ;
    --tw-invert: ;
    --tw-saturate: ;
    --tw-sepia: ;
    --tw-drop-shadow: ;
    --tw-backdrop-blur: ;
    --tw-backdrop-brightness: ;
    --tw-backdrop-contrast: ;
    --tw-backdrop-grayscale: ;
    --tw-backdrop-hue-rotate: ;
    --tw-backdrop-invert: ;
    --tw-backdrop-opacity: ;
    --tw-backdrop-saturate: ;
    --tw-backdrop-sepia: ;
}

.rounded-inherit {
    border-radius: inherit;
}

.overflow-hidden {
    overflow: hidden;
}

.inset-0 {
    bottom: 0;
    left: 0;
    right: 0;
    top: 0;
}

.absolute {
    position: absolute;
}

.pointer-events-none {
    pointer-events: none;
}

.scale-105,
.transform {
    -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.-translate-y-1\/2,
.translate-x-full {
    -webkit-transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.translate-x-full {
    --tw-translate-x: 100%;
}

.w-full {
    width: 100%;
}

.h-full {
    height: 100%;
}

.absolute {
    position: absolute;
}

.rotate-90 {
    --tw-rotate: 90deg;
}

.rotate-180 {
    --tw-rotate: 180deg;
}

.origin-center {
    -webkit-transform-origin: center;
    transform-origin: center;
}

.origin-top-left {
    -webkit-transform-origin: top left;
    transform-origin: top left;
}</style>